import ActionMenu, {
  ActionMenuItem,
} from "../../../components/actionMenu/ActionMenu";
import { useAppDispatch } from "../../../redux/hooks";
import { UnreceivedGoodsDataInterface } from "../../../redux/interfaces/receipt.interface";
import { deleteUnreceivedGoods } from "../../../redux/api/receipt.api";

function UnreceivedGoodsActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: UnreceivedGoodsDataInterface;
}) {
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(
      deleteUnreceivedGoods({
        id: itemId,
      }),
    );
  };
  const items: ActionMenuItem[] = [
    {
      id: "delete-unreceived-goods",
      label: "Sterge",
      icon: "DELETE",
      color: "error",
      tooltip: "Sterge inregistrarea de marfa nereceptionata dupa confirmare.",
      withConfirmationModal: {
        modalLeftButtonVariant: "outlined",
        modalTitle: "Doriti sa stergeti produsele?",
        modalRightButtonOnClick: handleDelete,
      },
    },
  ];

  return (
    <div>
      <ActionMenu
        items={items}
        minItemsForMenu={2}
        title={crudData.furnizor}
        ariaLabel={`Actiuni pentru marfa nereceptionata ${itemId}`}
      />
    </div>
  );
}

export default UnreceivedGoodsActionButtons;
